import type {
  ResourceProfileRebuildRunResult,
  ResourceProfileRebuildTask,
  ResourceProfileRebuildTaskList,
  ResourceProfileRebuildStatus,
} from "../types";

export type ResourceProfileRebuildTaskRaw = {
  task_key: string;
  task_name: string;
  description: string;
  rebuild_mode: "full";
  supports_preview: boolean;
  supports_execute: boolean;
};

export type ResourceProfileRebuildTaskListRaw = {
  items: ResourceProfileRebuildTaskRaw[];
};

export type ResourceProfileRebuildRunResultRaw = {
  task_key: string;
  task_name?: string;
  status: ResourceProfileRebuildStatus;
  scanned_count?: number;
  updated_count?: number;
  relation_deleted_count?: number;
  relation_inserted_count?: number;
  message: string;
};

/** 映射资源画像重算任务列表。 */
export function mapResourceProfileRebuildTaskList(
  raw: ResourceProfileRebuildTaskListRaw,
): ResourceProfileRebuildTaskList {
  return {
    items: (raw.items ?? []).map(mapResourceProfileRebuildTask),
  };
}

/** 映射资源画像重算任务。 */
function mapResourceProfileRebuildTask(
  raw: ResourceProfileRebuildTaskRaw,
): ResourceProfileRebuildTask {
  return {
    taskKey: raw.task_key,
    taskName: raw.task_name,
    description: raw.description,
    rebuildMode: raw.rebuild_mode,
    supportsPreview: raw.supports_preview,
    supportsExecute: raw.supports_execute,
  };
}

/** 映射资源画像重算结果。 */
export function mapResourceProfileRebuildRunResult(
  raw: ResourceProfileRebuildRunResultRaw,
): ResourceProfileRebuildRunResult {
  return {
    taskKey: raw.task_key,
    taskName: raw.task_name ?? "",
    status: raw.status,
    scannedCount: raw.scanned_count ?? 0,
    updatedCount: raw.updated_count ?? 0,
    relationDeletedCount: raw.relation_deleted_count ?? 0,
    relationInsertedCount: raw.relation_inserted_count ?? 0,
    message: raw.message,
  };
}
